// The reviewer's draft-queue order (utils/draftQueue.js DRAFT_ORDERS), kept
// per user (#313). A working style, not a restaurant filter, so not scoped by
// restaurant.
//
// Two layers. The choice made in this tab lives in module memory, which every
// screen reads first — /drafts and the review screen must always use the same
// order, even when storage refuses the write (a private window, blocked site
// data, a full quota; Codex review of #317). localStorage only carries the
// choice to the next visit, best effort.
import { DRAFT_ORDERS, DEFAULT_DRAFT_ORDER } from './draftQueue';

const keyFor = (uid) => `peak.draftQueueOrder.${uid ?? 'anon'}`;
const chosenThisTab = new Map();

export function readDraftOrder(uid) {
  const key = keyFor(uid);
  if (chosenThisTab.has(key)) return chosenThisTab.get(key);
  try {
    const v = window.localStorage.getItem(key);
    return DRAFT_ORDERS.includes(v) ? v : DEFAULT_DRAFT_ORDER;
  } catch {
    return DEFAULT_DRAFT_ORDER;
  }
}

export function writeDraftOrder(uid, mode) {
  if (!DRAFT_ORDERS.includes(mode)) return;
  const key = keyFor(uid);
  chosenThisTab.set(key, mode);
  try {
    window.localStorage.setItem(key, mode);
  } catch {
    // Not remembered for the next visit; this tab still uses the choice.
  }
}

/** Tests only: forget the choices made in this tab. */
export const forgetDraftOrdersForTests = () => { chosenThisTab.clear(); };
